// extracted by mini-css-extract-plugin
export var contrastLow = "_1x-1";
export var externalLink = "_1x-2";
export var externalLinkIcon = "_1x-3";
export var link = "_1x-0";
export var linkLabel = "_1x-4";